import { render, staticRenderFns } from "./P2PDeals.vue?vue&type=template&id=18ef4932&scoped=true&"
import script from "./P2PDeals.vue?vue&type=script&lang=js&"
export * from "./P2PDeals.vue?vue&type=script&lang=js&"
import style0 from "./P2PDeals.vue?vue&type=style&index=0&id=18ef4932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef4932",
  null
  
)

export default component.exports